export default __webpack_public_path__ + "static/media/syr.448e41d3.svg";